export default __webpack_public_path__ + "2608adb66b3b0d1b8348ab180251e03c.gif";